var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('dv-decoration-4',{staticStyle:{"width":"7px","height":"70px"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }